import { Key } from 'src/types/keys.enum';
import React from 'react';

/**
 * This file is not unit-tested because I was unable to get KeyboardEvents to function correctly
 */

export function isKeyboardKey(event: React.KeyboardEvent, key: Key): boolean {
    if (key === Key.SPACE) return (event.code as Key) === Key.SPACE;
    return (event.key as Key) === key;
}

export function isOneOfKeyboardKeys(event: React.KeyboardEvent, keys: Key[]): boolean {
    return keys.some((key: Key) => isKeyboardKey(event, key));
}
